import { sum } from 'es-toolkit';
import { getAdsWithCredits } from '../global-state/usage-data';
import { Episode } from '../models/podcasts';
import { isPlayable } from './helpers';

export default function getAdsStatus(
  episode: Episode,
  showAdsLength = false,
  showCredits = true
) {
  if (episode.url) return 'Ad-skipping disabled';

  const adCount = (episode.ads && episode.ads.length) || 0;
  if (adCount && episode.duration) {
    const creditCount = sum(
      getAdsWithCredits(episode.ads!, episode.duration).map((ad) => ad.credits)
    );
    const adText = adCount > 1 ? 'ads' : 'ad';
    const creditText = creditCount > 1 ? 'credits' : 'credit';
    return showAdsLength
      ? `${adCount} ${adText} detected` +
          (showCredits ? ` • ${creditCount} ad-skip ${creditText}` : ' ✓')
      : `Ads detected` + (showCredits ? ` (${creditCount} ${creditText})` : ' ✓');
  }

  if (episode.ads) return 'No ads detected ✓';

  // Not playable in app (video or unsupported audio). We already tell user so no need to say it again here.
  if (!isPlayable(episode)) return '';

  if (episode.status === 'ad_detection_failed') return 'Ad detection failed';
  if (episode.status === 'audio_download_failed') return 'Audio not available';
  if (episode.status === 'detecting_ads') return 'Finding ads...';
  return 'Queued';
}

// // 7 -> ⑦
// function numberInCircle(int: number) {
//   return String.fromCodePoint(parseInt('0x' + (9311 + int).toString(16)));
// }
